import { SDUIOnClickHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { ISDUIProductTileVariantRendererProps } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/types";
import { SDUIProductTileEvaluateRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/variants/SDUIProductTileEvaluateRenderer";
import { SDUITileInstanceRendererProps } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/types";
import { ITile } from "@faire/web-api--source/indigofair/data/ITile";
import React from "react";

export const SDUIProductTileRenderer = ({
  tileElement,
  loggingData,
  renderBehaviour,
}: SDUITileInstanceRendererProps) => {
  const { on_click } = tileElement;
  const { product, brand_info, variant } = tileElement.product_tile ?? {};
  if (product === undefined || variant === undefined) {
    return null;
  }

  const SDUIProductTileVariantRenderer =
    SDUIProductTileVariantRendererMap[variant];
  if (SDUIProductTileVariantRenderer === undefined) {
    return null;
  }
  return (
    <SDUIOnClickHandler onClickActions={on_click} loggingData={loggingData}>
      <SDUIProductTileVariantRenderer
        product={product}
        brand={brand_info}
        loggingData={loggingData}
        renderBehaviour={renderBehaviour}
      />
    </SDUIOnClickHandler>
  );
};

const SDUIProductTileVariantRendererMap: Partial<
  Record<
    ITile.ProductTileVariant,
    React.FC<ISDUIProductTileVariantRendererProps> | undefined
  >
> = {
  // todo: BE is sending DEFAULT_PRODUCT_TILE for evaluate tiles. We should update the BE to send EVALUATE_TILE instead.
  [ITile.ProductTileVariant.DEFAULT_PRODUCT_TILE]:
    SDUIProductTileEvaluateRenderer,
  [ITile.ProductTileVariant.EVALUATE_TILE]: SDUIProductTileEvaluateRenderer,
  [ITile.ProductTileVariant.PRODUCT_TILE_VARIANT_UNKNOWN]: undefined,
};
